<template>
   <div class="question" style="display: flex;" >
       <div class="left" style="flex:1"></div>
       <div class="right" style="width: 800px;">

         <div style="width: 100%;background-color: #f5f5f5;padding-top: 15px;" class="top">
           <div style="flex: 1;">
             <h3 style="text-indent: 15px;font-size: 30px;background-color: #f5f5f5;">【答疑】</h3>

                            <div style="background-color: #f5f5f5;padding: 5px 0;">&nbsp;&nbsp;&nbsp;&nbsp;先看看其他同学的答疑是否解决了您的问题吧~</div>
           </div>
           <img @click="handleCloseWin" src="../assets/img/delpic.png" width="20" height="20" style="position: fixed;right: 30px;z-index: 1988;top: 30px;cursor: pointer;" />

         </div>
         <div style="height: 86px;"></div>

          <div class="container-fluid" style="width: 100%;min-width:200px;">
          	<div class="row-fluid panels" style="min-width:200px;">
          		<div class="pep panels" style="width:100%;">
          			<div class="col-xs-12">
          				<div class="panel panel-default pagebox">
          					<div class="panel-heading blod">
          						试题答疑
          						<!-- <a class="btn btn-primary pull-right" href="#faqask">发布提问</a> -->
          					</div>
          															<div class="panel-body">
          						<div class="panel panel-default pagebox" v-for="item in list">
          							<div class="panel-heading blod" style="color:#02756E;">
          								{{item.nickName}}
          							</div>
          							<div class="panel-body">
          								{{item.content}}							</div>
          														<div class="panel-body blod" style="background-color:#f5f5f5;">
                                        <h4 style="color:#d9534f;font-size:16px;font-weight:600" v-if="item.teacherReplyContent">教师回复</h4>
          								<p v-html="item.teacherReplyContent">{{请仔细描述你的问题以便老师及时解答}}</p>							</div>
          													</div>
          					</div>
          																			</div>

          				<div class="panel panel-default pagebox">
          					<div class="panel-heading blod" id="faqask">
          						发布提问
          					<!-- 	<a class="btn btn-default pull-right" href="#"><i class="glyphicon glyphicon-open"></i> 回顶部</a> -->
          					</div>
          					<div class="panel-body">
          						<form class="pagebox notes" action="index.php?exam-app-point-faq" method="post">
          							<textarea v-model="content" class="form-control" name="args[faqask]" style="height: 160px;" needle="needle" msg="请填写提问内容" autocomplete="off"></textarea>
          							<div class="text-right">
          								<input type="hidden" name="savefaq" value="1" autocomplete="off">
          								<input type="hidden" name="args[faqquestionid]" value="205506" autocomplete="off">
          								<button type="button" class="btn btn-primary" style="margin: 10px 0px;" autocomplete="off" @click="handleSubmit">发布提问</button>
          							</div>
          						</form>
          					</div>
          				</div>
          			</div>
          		</div>
          	</div>
          </div>
       </div>
   </div>
</template>

<script>
  let timer;
  export default {
    name: 'Footer',
    components:{

    },
    props:{
      questionId:{
          type:String,
          default:()=>''
      },
    },
    data () {
      return {
        content:'',
        list:[]
      }
    },
    methods:{
        handleCloseWin(){
          this.$emit('closewin')
        },
        handleSubmit(){
          if(this.content==''){

            alert('请填写您的问题')

            return
          }

          let data=new FormData();
              data.append('questionId',this.questionId);
              data.append('content',this.content);
          this.$axios.post(this.$common.questionComment_sub,data).then((res)=>{
                if(res.data.code==1){
                    this.content=''
                    alert('提交成功')
                    this.getData()


                }
                else {
                  alert(res.data.msg)
                }
          })
        },
        getData(){
          this.$axios.get(this.$common.questionComment_index+'?questionId='+this.questionId).then((res)=>{
                if(res.data.code==1){


                    this.list=res.data.data;

                }
                else {
                  alert(res.data.msg)
                }
          })
        }
    },
    created() {
      document.querySelector('body').className='overflowhidden'
      this.getData();
    },
    beforeDestroy() {
      document.querySelector('body').className=''
    }
  }
</script>

<style scoped>
  >>> .test {
    overflow: hidden;
  }
  .question {
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1988;
    width: 100%;
    z-index: 1988;
    height: 100vh;
    overflow: hidden;
  }
  .top {
    position: fixed;
    width: 100%;
  }
  .right {
    height: 100vh;
    overflow-y: auto;
    padding-left: 10px;
    box-shadow: 0 0 10px #ccc;
    background-color: #f5f5f5;
  }
  .container-fluid {
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
      height: calc(100vh - 86px);
      overflow-y: auto;
      margin-top: 150px;
  }
  .container-fluid, .row-fluid {
      padding: 0px;
      margin: 0px;
      width: 100%;
      min-width: 1400px;
  }
  .row-fluid.panels {
      background-color: #f5f5f5;
  }
  .pep {
      width: 85rem;
      clear: both;
      display: block;
      margin: 0px auto;
      font-size: 16px;
  }
  .pep.panels {
      background-color: #f5f5f5;
      overflow: hidden;
      color: #000000;
      padding-top: 1rem;
  }
  .pep.panels:last-child {
      padding-bottom: 1rem;
  }
  .col-xs-12 {
      width: 100%;
  }
  .panel {
      margin-bottom: 20px;
      background-color: #fff;
      border: 1px solid transparent;
      border-radius: 4px;
      -webkit-box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
      box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
  }
  .panel-default {
      border-color: #ddd;
  }
  .pep.panels .pagebox {
      border-radius: 0px;
      overflow: hidden;
  }
  .panel-heading {
      padding: 10px 15px;
      border-bottom: 1px solid transparent;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
  }
  .panel-default > .panel-heading {
      color: #333;
      background-color: #f5f5f5;
      border-color: #ddd;
  }
  .pep.panels .pagebox .panel-heading {
      line-height: 40px;
  }
  .pep.panels .pagebox .panel-heading.blod {
      font-weight: bold;
  }
  .pep.panels .pagebox .panel-body {
      padding: 1rem;
  }
  .btn {
      display: inline-block;
      padding: 6px 12px;
      margin-bottom: 0;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.42857143;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      -ms-touch-action: manipulation;
      touch-action: manipulation;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      background-image: none;
      border: 1px solid transparent;
      border-radius: 4px;
  }
  .btn-primary {
      color: #fff;
      background-color: #337ab7;
      border-color: #2e6da4;
  }
  .pull-right {
      float: right !important;
  }
  .btn {
      position: relative;
  }
  .pep.panels a {
      color: #000000;
      text-decoration: none;
  }
  .pep.panels .pagebox .btn {
      margin-right: 2rem;
      padding: 10px 20px;
      border-radius: 0px;
  }
  .pep.panels .pagebox .btn.btn-primary {
      color: #FFFFFF;
      background-color: #02756E;
      border-color: #02756E;
  }
  .glyphicon {
      position: relative;
      top: 1px;
      display: inline-block;
      font-family: 'Glyphicons Halflings';
      font-style: normal;
      font-weight: normal;
      line-height: 1;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
  }
  .glyphicon-question-sign:before {
      content: "\e085";
  }
  .form-control {
      display: block;
      width: 90%;
      height: 34px;
      padding: 6px 12px;
      font-size: 14px;
      line-height: 1.42857143;
      color: #555;
      background-color: #fff;
      background-image: none;
      border: 1px solid #ccc;
      border-radius: 4px;
      -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
      box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
      -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
      -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
      transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
      outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/questionAnswering.vue